module.exports = __webpack_public_path__ + "static/img/bigdatacorp-logo.90d32556.png";